import { Input } from '@polichat/flamboyant';
import { useCallback } from 'react';

// Hook customizado para formatação de moeda
const useCurrencyFormatter = (locale = 'pt-BR', currency = 'BRL') => {
  const formatCurrency = useCallback(
    (value: number): string => {
      // Converte centavos para reais (divide por 100)
      const valueInReais = value / 100;

      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(valueInReais);

      return formatted;
    },
    [locale, currency]
  );

  const parseCurrency = useCallback((value: string): number => {
    const numericValue = value.replace(/[^\d]/g, '');
    const result = numericValue ? parseInt(numericValue, 10) : 0;
    return result;
  }, []);

  const formatCurrencyInput = useCallback(
    (value: string): string => {
      // Remove tudo que não é dígito
      const cleanValue = value.replace(/[^\d]/g, '');
      if (!cleanValue) return '';
      // Converte para número
      const numericValue = parseInt(cleanValue, 10);
      // Formata como moeda
      const result = formatCurrency(numericValue);
      return result;
    },
    [formatCurrency]
  );

  return { formatCurrency, parseCurrency, formatCurrencyInput };
};
interface CurrencyFieldProps {
  id: string;
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  invalid?: boolean;
  error?: string;

  'data-testid'?: string;
}

export function CurrencyField({
  id,
  value,
  onChange,
  placeholder,
  error,
  'data-testid': dataTestId,
}: CurrencyFieldProps) {
  const { formatCurrency, parseCurrency, formatCurrencyInput } =
    useCurrencyFormatter();

  const displayValue = formatCurrency(value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const formattedValue = formatCurrencyInput(value);
    onChange(parseCurrency(formattedValue));
  };

  return (
    <Input
      type="text"
      id={id}
      placeholder={placeholder}
      invalid={!!error}
      value={displayValue}
      onChange={handleChange}
      data-testid={dataTestId ?? `finish-chat-currency-field-${id}`}
    />
  );
}
